import styled from "styled-components"

const Infos = styled.h3`
  color: ${(props) => props.theme.c_color_gradients.c_dark};
`

export { Infos }
